<template>
  <div class="container my-3 d-flex justify-content-center">
    <div
      class="card shadow p-2 mt-3 rounded bb-card bb-campaign-setup-card"
      style="width: 50%"
    >
      <div class="card-body">
        <!-- ------------ -->
        <!--    form      -->
        <!-- ------------ -->
        <form @submit.prevent>
          <!-- row 1 -->
          <div class="row">
            <!-- col 1: image -->
            <div class="col-sm-4">
              <!-- -------------- -->
              <!-- campaign image -->
              <!-- -------------- -->
              <div class="form-group text-center">
                <div class="form-floating mt-3 mb-2">
                  <img
                    v-bind:src="image"
                    height="200"
                    width="350"
                    class="img-fluid rounded border border-dark bb-image-container"
                    alt="campaign image"
                  />
                </div>
                <!-- ------------------- -->
                <!--   image selection   -->
                <!-- ------------------- -->
                <label class="btn btn-dark btn-file mb-2 bb-click-label">
                  Change Image
                  <input
                    type="file"
                    accept="image/*"
                    style="display: none"
                    id="selectImage"
                    @change="previewImage"
                  />
                </label>
              </div>
            </div>
            <!-- col 2 -->
            <div class="col-sm-8">
              <!-- col 2/row 1 -->
              <div class="row">
                <!-- -------------- -->
                <!--  campaign name -->
                <!-- -------------- -->
                <div class="form-group">
                  <div class="form-floating mt-3 mb-3">
                    <input
                      v-model="arena_name"
                      v-bind:class="{
                        'is-invalid': errorFields.includes('name'),
                      }"
                      id="arena_name"
                      placeholder="campaign name..."
                      type="text"
                      class="form-control capitalize"
                      autocomplete="off"
                      required
                    />
                    <label
                      class="bb-float-label"
                      for="arena_name"
                      >Campaign Name</label
                    >
                  </div>
                </div>
              </div>
              <!-- col 2/row 2 -->
              <div class="row">
                <!-- -------------- -->
                <!--  description   -->
                <!-- -------------- -->
                <div class="form-group">
                  <div class="form-floating mt-3 mb-3">
                    <textarea
                      style="height: 150px"
                      v-model="arena_description"
                      v-bind:class="{
                        'is-invalid': errorFields.includes('description'),
                      }"
                      class="form-control capitalize bb-textarea-with-label"
                      placeholder="description..."
                      rows="4"
                    ></textarea>
                    <label
                      class="bb-float-label"
                      for="arena_description"
                      >Description</label
                    >
                  </div>
                </div>
              </div>
              <!-- col 2/row 3 -->
              <div class="row">
                <div class="form-group">
                  <div class="form-floating mt-1 mb-3">
                    <input
                      readonly
                      disabled
                      :value="dmDisplayName"
                      id="arena_dm"
                      type="text"
                      class="form-control"
                    />
                    <label
                      class="bb-float-label"
                      for="arena_dm"
                      >DM</label
                    >
                  </div>
                </div>
              </div>
              <!-- ------------ -->
              <!--    players   -->
              <!-- ------------ -->
              <!-- col 2/row 5 -->
              <div class="row mt-2 bb-players-row">
                <label class="mb-2 bb-sub-hdg px-3">Players</label>
                <div class="form-group">
                  <!-- :preserve-search="true" typo__label  -->
                  <!-- :max="players.length" -->
                  <div class="bb-campaign-player-select">
                    <VueMultiselect
                      v-model="selections"
                      :class="[
                        'bb-campaign-player-multiselect',
                        {
                          'is-invalid': errorFields.includes('players'),
                        },
                      ]"
                      :options="players"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preselect-first="false"
                      :hide-selected="true"
                      :max="players.length"
                      label="user_name"
                      track-by="user_name"
                      placeholder="Search Players..."
                    >
                      <template v-slot:noResult>
                        <span>No matching results</span>
                      </template>
                      <template v-slot:noOptions>
                        <span>No options to select</span>
                      </template>
                      <template v-slot:maxElements>
                        <span v-if="this.players.length > 0"
                          >No futher options to select</span
                        >
                        <span v-else></span>
                      </template>
                      <!-- hide spinner if no options -->
                      <template v-slot:caret>
                        <span
                          v-if="
                            !this.players ||
                            this.players.length == this.selections.length
                          "
                        ></span>
                      </template>
                    </VueMultiselect>
                  </div>
                </div>
              </div>
              <!-- col 2/row 5 -->
              <div class="row mt-3">
                <div class="form-group">
                  <!-- ------------ -->
                  <!--    errors    -->
                  <!-- ------------ -->
                  <div
                    v-for="err in errors"
                    :key="err.id"
                    class="bb-error"
                  >
                    {{ err }}
                  </div>
                </div>
              </div>
              <!-- col 2/row 3 -->
              <div class="text-end bb-campaign-actions">
                <!-- ------------ -->
                <!--    cancel    -->
                <!-- ------------ -->
                <button
                  type="submit"
                  @click="this.$router.go(-1)"
                  class="btn btn-lg btn-primary mt-3 mb-3 me-4 responsive-width"
                >
                  Cancel
                </button>
                <!-- ------------ -->
                <!--    delete    -->
                <!-- ------------ -->
                <button
                  type="submit"
                  :disabled="local_slug == null"
                  @click="confirmDeletion()"
                  class="btn btn-lg btn-danger mt-3 mb-3 me-4 responsive-width"
                >
                  Delete
                </button>
                <confirm-dialog ref="confirmDialog"></confirm-dialog>
                <!-- ------------ -->
                <!--     save     -->
                <!-- ------------ -->
                <button
                  type="submit"
                  @click="editArena()"
                  :disabled="!isArenaChanged && !isImageChanged"
                  class="btn btn-lg btn-primary mt-3 mb-3 responsive-width"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { axios } from '@/common/api.service.js'
import { mapGetters } from 'vuex'

import store from '../store/index'

import VueMultiselect from 'vue-multiselect'

import defaultImage from '../assets/images/default-arena-image.png'
import ConfirmDialog from '../components/ConfirmDialog.vue'

//----------------------
// scripts
//----------------------
export default {
  name: 'campaignSetup',
  //----------------------
  // components
  //----------------------
  components: {
    VueMultiselect,
    ConfirmDialog,
  },
  //----------------------
  // props
  //----------------------
  props: {
    slug: {
      type: String,
      required: false,
    },
  },
  //----------------------
  // data
  //----------------------
  data() {
    return {
      errors: [],
      errorFields: [],
      deleteInd: false,
      arena_name: '',
      arena_description: '',
      arena_image: null,
      arena_file: null,
      sv_arena_name: '',
      sv_arena_description: '',
      sv_arena_image: '',
      sv_selections: [],
      new_slug: null,
      endpoint: 'api/v1/campaigns/',
      players: [],
      selections: [],
      defaultImage,
    }
  },
  //----------------------
  // computed
  //----------------------
  computed: {
    selection_text: function () {
      if (this.selections) {
        if (this.selections.length == 1) {
          return 'player'
        } else {
          return 'players'
        }
      } else {
        return 'player'
      }
    },
    image: function () {
      if (this.arena_image != null) {
        return this.arena_image
      } else {
        return this.defaultImage
      }
    },
    ...mapGetters('auth', {
      getHeaders: 'getHeaders',
      getImgHeaders: 'getImgHeaders',
      getUserProfile: 'getUserProfile',
    }),
    dmDisplayName() {
      return this.getUserProfile?.user_name || this.getUserProfile?.email || ''
    },
    isArenaChanged() {
      if (
        this.sv_arena_description != this.arena_description ||
        this.sv_arena_name != this.arena_name ||
        JSON.stringify(this.sv_selections) != JSON.stringify(this.selections)
      ) {
        if (this.arena_name) {
          return true
        }
      }
      return false
    },
    isImageChanged() {
      if (this.sv_arena_image != this.arena_image && this.arena_image) {
        return true
      }
      return false
    },
    local_slug() {
      if (this.new_slug != null) {
        return this.new_slug
      } else if (this.$route.params.slug != null) {
        return this.$route.params.slug
      }
      return null
    },
    isNewCampaign() {
      return this.$route.params.slug === null || this.$route.params.slug === undefined
    },
    api_request() {
      return window.bbAPIRequest(this.endpoint, this.local_slug, this.deleteInd)
    },
  },
  //----------------------
  // methods
  //----------------------
  methods: {
    //----------------------
    // confirm deletion
    //----------------------
    async confirmDeletion() {
      const ok = await this.$refs.confirmDialog.show({
        title: 'Delete Campaign',
        message: 'Confirm Deletion',
        okButton: 'OK',
        cancelButton: 'Cancel',
      })
      if (ok) {
        this.deleteArena()
      }
    },
    //--------------------------------------------
    // get existing campaign
    //--------------------------------------------
    async getCampaign() {
      // set vars
      const endpoint = `api/v1/campaigns/${this.local_slug}/`
      const headers = store.getters['auth/getHeaders']
      // make call
      await axios({
        method: 'get',
        url: endpoint,
        headers: headers,
      })
        // success
        .then((response) => {
          // get fields
          this.arena_name = response.data.name
          this.arena_description = response.data.description
          this.arena_image = response.data.image
          this.selections = response.data.players
          // save original fields
          this.sv_arena_name = response.data.name
          this.sv_arena_description = response.data.description
          this.sv_arena_image = response.data.image
          this.sv_selections = response.data.players
        })
        // error
        .catch(function (error) {
          console.log(error)
        })
    },
    //-------------------------------------
    // change arena controller
    //-------------------------------------
    async editArena() {
      this.errors = []
      this.errorFields = []
      const canContinue = await this.confirmUnenrolmentImpact()

      if (!canContinue) {
        return
      }
      //---------------------------------------
      // where detail changes (defaults image)
      //--------------------------------------------------
      // will call image update from here if both changed
      //--------------------------------------------------
      if (this.isArenaChanged) {
        this.editDetails()
      }
      //---------------------------
      // where only image changed
      //---------------------------
      else if (this.isImageChanged) {
        this.updateImage()
      }
    },
    getRemovedPlayerUserNames() {
      const currentUserNames = new Set(
        (this.selections || [])
          .map((selection) => selection?.user_name)
          .filter(Boolean),
      )

      return (this.sv_selections || [])
        .map((selection) => selection?.user_name)
        .filter((userName) => userName && !currentUserNames.has(userName))
    },
    async confirmUnenrolmentImpact() {
      if (!this.isArenaChanged || !this.local_slug) {
        return true
      }

      const removedPlayerUserNames = this.getRemovedPlayerUserNames()

      if (removedPlayerUserNames.length === 0) {
        return true
      }

      const impacts = await this.fetchUnenrolmentImpact()

      if (impacts === null) {
        return false
      }

      if (!impacts.length) {
        return true
      }

      return this.$refs.confirmDialog.show({
        title: 'Player Unenrolment Warning',
        message:
          'Removing campaign players will affect linked characters. Press OK to continue or Cancel to keep current enrolment.',
        subject: this.buildUnenrolmentImpactText(impacts),
        okButton: 'OK',
        cancelButton: 'Cancel',
      })
    },
    buildUnenrolmentImpactText(impacts = []) {
      return impacts
        .map((impact) => {
          if (impact.action === 'clear_player') {
            return `${impact.character_name}: ${impact.player_name} will be removed from this NPC record.`
          }

          return `${impact.character_name}: this Character record will be deleted.`
        })
        .join('\n')
    },
    async fetchUnenrolmentImpact() {
      const endpoint = `api/v1/campaigns/${this.local_slug}/unenrolment-impact/`
      const payload = {
        player_ids: this.selections.map((item) => item.user_name),
      }

      try {
        const response = await axios({
          method: 'post',
          url: endpoint,
          headers: this.getHeaders,
          data: payload,
        })

        return response.data.impacts || []
      } catch (err) {
        const error = window.getErrorMessage(err)
        this.errors.push(window.bbErrorMsg(error))
        this.errorFields.push(window.bbErrorKey(error))
        return null
      }
    },
    //-------------------------------------
    // add/change arena details
    //-------------------------------------
    async editDetails() {
      //----------------------
      // get player ids
      //----------------------
      const playerIds = this.selections.map((item) => item.user_name)
      const payload = {
        name: this.arena_name,
        description: this.arena_description,
        player_ids: playerIds,
      }
      //----------------------
      // api call
      //----------------------
      await axios({
        method: this.api_request.method,
        url: this.api_request.endpoint,
        headers: this.getHeaders,
        data: payload,
      })
        //----------------------
        // where successful
        //----------------------
        .then((response) => {
          this.new_slug = response.data['slug']
          if (this.isImageChanged) {
            this.updateImage()
          } else {
            this.$router.push({
              name: 'campaignsView',
              query: {
                campaign_name: this.arena_name,
                action: this.isNewCampaign ? 'created' : 'updated',
              },
            })
          }
        })
        //----------------------
        // where error
        //----------------------
        .catch((err) => {
          const error = window.getErrorMessage(err)
          this.errors.push(window.bbErrorMsg(error))
          this.errorFields.push(window.bbErrorKey(error))
        })
    },
    //-------------------------------------
    // delete campaign
    //-------------------------------------
    async deleteArena() {
      this.deleteInd = true
      //----------------------
      // api call
      //----------------------
      await axios({
        method: this.api_request.method,
        url: this.api_request.endpoint,
        headers: this.getHeaders,
      })
        //----------------------
        // where successful
        //----------------------
        .then(() => {
          this.$router.push({
            name: 'campaignsView',
            query: {
              campaign_name: this.arena_name,
              action: 'deleted',
            },
          })
        })
        //----------------------
        // where error
        //----------------------
        .catch((err) => {
          const error = window.getErrorMessage(err)
          this.errors.push(window.bbErrorMsg(error))
          this.errorFields.push(window.bbErrorKey(error))
        })
    },
    //-------------------------------------
    // update image
    //-------------------------------------
    async updateImage() {
      const endpoint = `api/v1/campaigns/${this.local_slug}/image/`
      //----------------------
      // api call
      //----------------------
      await axios({
        method: 'PATCH',
        url: endpoint,
        headers: this.getImgHeaders,
        data: this.arena_file,
      })
        //----------------------
        // where successful
        //----------------------
        .then(() => {
          this.$router.push({
            name: 'campaignsView',
            query: {
              campaign_name: this.arena_name,
              action: 'updated',
            },
          })
        })
        //----------------------
        // where error
        //----------------------
        .catch((err) => {
          const error = window.getErrorMessage(err)
          this.errors.push(window.bbErrorMsg(error))
          this.errorFields.push(window.bbErrorKey(error))
        })
    },
    //-------------------------------------
    // preview image
    //-------------------------------------
    async previewImage(event) {
      const file = event.target.files?.[0]

      if (!file) {
        return
      }

      const url = await this.readURL(file)
      this.arena_image = url

      const formData = new FormData()
      formData.append('image', file)
      this.arena_file = formData
    },
    //-------------------------------------
    // convert file to data url
    //-------------------------------------
    readURL(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (loadEvent) => resolve(loadEvent.target.result)
        reader.onerror = (error) => reject(error)
        reader.readAsDataURL(file)
      })
    },
    //------------------------------
    // get players (for selection)
    //------------------------------
    async getPlayers() {
      this.errors = []
      this.players = []
      //-------------------------
      // setup call parms
      //-------------------------
      const headers = store.getters['auth/getHeaders']
      const endpoint = 'api/v1/user/players/'
      //----------------------
      // api call
      //----------------------
      await axios
        .get(endpoint, {
          headers: headers,
        })
        //----------------------
        // where successful
        //----------------------
        .then((response) => {
          const values = response.data.results || []
          const currentDmUserName = this.getUserProfile?.user_name || null

          this.players.push(...values)
          if (currentDmUserName) {
            this.players = this.players.filter(
              (entry) => entry?.user_name !== currentDmUserName,
            )
          }
        })
        //----------------------
        // where error
        //----------------------
        .catch((err) => {
          if (err.response) {
            const errMsgArray = err.response.data.non_field_errors
            for (var i = 0; i < errMsgArray.length; i++) {
              this.errors.push(errMsgArray[i].toString())
            }
          }
        })
    },
  },
  //----------------------
  // mounted
  //----------------------
  mounted() {
    this.getPlayers()
    if (this.local_slug != null) {
      this.getCampaign()
    }
  },
}
</script>

<style>
.bb-campaign-setup-card {
  min-height: 52rem;
}

.bb-players-row {
  margin-top: 1rem !important;
}

.bb-campaign-actions {
  margin-top: 0.25rem;
  padding-top: 0;
  transform: translateY(-0.35rem);
}

.bb-campaign-player-select {
  min-height: 18rem;
  padding: 2.35rem 1.5rem 1.6rem;
  background: black;
  border: 1px solid #333333;
  border-radius: 5px;
  overflow: visible;
  font-size: 1.5rem;
}

.bb-campaign-player-multiselect,
.bb-campaign-player-select .multiselect {
  box-sizing: border-box !important;
  min-height: 0 !important;
  height: auto !important;
  background: transparent !important;
  border: none !important;
}

.bb-campaign-player-select .multiselect__tags-wrap {
  display: block;
}

.bb-campaign-player-multiselect .multiselect__tags,
.bb-campaign-player-select .multiselect__tags {
  box-sizing: border-box !important;
  min-height: 14rem !important;
  height: auto !important;
  padding: 0 3.75rem 0 0 !important;
  font-size: 1.45rem !important;
  margin: 0 !important;
  background: transparent !important;
  border: none !important;
}

.bb-campaign-player-multiselect .multiselect__current,
.bb-campaign-player-select .multiselect__current {
  min-height: 14rem !important;
  height: auto !important;
  padding: 5rem 3rem 0 0 !important;
  background: transparent !important;
}

.bb-campaign-player-multiselect .multiselect__placeholder,
.bb-campaign-player-select .multiselect__placeholder {
  display: block !important;
  margin-top: 4.85rem !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-left: 0 !important;
}

.bb-campaign-player-multiselect .multiselect__placeholder,
.bb-campaign-player-multiselect .multiselect__input,
.bb-campaign-player-multiselect .multiselect__single,
.bb-campaign-player-select .multiselect__placeholder,
.bb-campaign-player-select .multiselect__input,
.bb-campaign-player-select .multiselect__single {
  font-size: 1.45rem !important;
  line-height: 1.45 !important;
}

.bb-campaign-player-multiselect .multiselect__input,
.bb-campaign-player-multiselect .multiselect__single,
.bb-campaign-player-select .multiselect__input,
.bb-campaign-player-select .multiselect__single {
  min-height: 2.8rem !important;
  height: 2.8rem !important;
  margin-top: 4.7rem !important;
  margin-bottom: 0.35rem !important;
  padding-left: 0 !important;
}

.bb-campaign-player-select .multiselect--active .multiselect__current {
  min-height: 0 !important;
  padding-top: 0 !important;
}

.bb-campaign-player-select .multiselect--active .multiselect__input,
.bb-campaign-player-select .multiselect--active .multiselect__single {
  margin-top: 0.65rem !important;
  margin-bottom: 0.65rem !important;
}

.bb-campaign-player-select .multiselect--active .multiselect__tags {
  padding-top: 0.75rem !important;
}

.bb-campaign-player-select .multiselect--active .multiselect__content-wrapper {
  top: calc(100% + 0.5rem) !important;
  bottom: auto !important;
}

.bb-campaign-player-select .multiselect__tag {
  padding: 0.85rem 2.75rem 0.85rem 1rem !important;
  margin-right: 0.85rem !important;
  margin-bottom: 0.85rem !important;
  font-size: 1.35rem !important;
  line-height: 1.25 !important;
  border-radius: 0.6rem !important;
}

.bb-campaign-player-select .multiselect__tag-icon {
  width: 2.25rem !important;
  line-height: 2.25rem !important;
}

.bb-campaign-player-select .multiselect__tag-icon::after {
  font-size: 1.35rem !important;
}

.bb-campaign-player-select .multiselect__select {
  width: 3.5rem !important;
  min-height: 100% !important;
  height: 100% !important;
  top: 0 !important;
  bottom: 0 !important;
  right: 0 !important;
  padding: 0 !important;
  background: transparent !important;
}

.bb-campaign-player-select .multiselect__select::before {
  border-width: 0.65rem 0.65rem 0 0.65rem !important;
}

.bb-campaign-player-select .multiselect__content-wrapper {
  max-height: 24rem !important;
}

.bb-campaign-player-select .multiselect__option,
.bb-campaign-player-select .multiselect__noResult,
.bb-campaign-player-select .multiselect__noOptions {
  padding: 1.15rem 1.2rem !important;
  min-height: 4rem !important;
  font-size: 1.35rem !important;
  line-height: 1.4 !important;
}
</style>
